module.exports = __webpack_public_path__ + "img/icon-appointment-success.bd22c8e6.png";